import type { CategoryResponse } from "@models/category";

export interface FlatCategory {
    id: number;
    name: string;
    // Breadcrumb display name, e.g. "THC / CBD".
    displayName: string;
}

const PATH_SEPARATOR = " / ";

// Depth-first walk that builds a flat list of categories with breadcrumb
// display names. Used by the search Autocomplete to prefix-match across the
// full category tree, not just top-level names.
export const flattenCategories = (
    categories: CategoryResponse[],
): FlatCategory[] => {
    const result: FlatCategory[] = [];

    const walk = (nodes: CategoryResponse[], parentPath: string) => {
        for (const node of nodes) {
            const displayName = parentPath
                ? `${parentPath}${PATH_SEPARATOR}${node.name}`
                : node.name;
            result.push({ id: node.id, name: node.name, displayName });
            if (node.children?.length) {
                walk(node.children, displayName);
            }
        }
    };

    walk(categories, "");
    return result;
};
